import * as React from 'react'
import { SVGProps } from 'react'
const SvgUndo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 7.2V0L0 12l12 12v-8c12-.54 15.06 7.52 15.76 11.54a.54.54 0 0 0 1.06 0C34.16 5.72 12 7.2 12 7.2Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgUndo
